import type { WebOrdersMoney } from "../../../api/types";
import { euro } from "../../finances/opcostFormat";

/**
 * "Margin" as the web-orders report shows it (G-168: revenue before IVA −
 * cost of goods, before commission; the API field is still `profitEur`).
 * When some sold stock had no known cost (OD-198), the cost is understated
 * and the margin overstated, so the figure says so instead of passing for
 * exact.
 */
export function marginText(m: Pick<WebOrdersMoney, "profitEur" | "unknownCostLines"> | null | undefined): string {
  if (!m) return euro("0");
  return m.unknownCostLines > 0 ? `${euro(m.profitEur)} · cost incomplete` : euro(m.profitEur);
}
